import { newAPI } from 'services';
import qs from 'qs';

export const requestToken = async (userId, businessUuid, userIntegrationId) => {
  const response = await newAPI.get(`${userId}/business/${businessUuid}/integrations/show/${userIntegrationId}`);
  return response.data;
}

export const requestCreateToken = async (userId, businessUuid, params) => {
  const response = await newAPI.post(`${userId}/business/${businessUuid}/integrations/new`, qs.stringify(params));
  return response.data;
}

export const requestUpdateToken = async (userId, businessUuid, userIntegrationId, params) => {
  const response = await newAPI.put(`${userId}/business/${businessUuid}/integrations/update/${userIntegrationId}`, qs.stringify(params));
  return response.data;
}

export const requestRenewToken = async (userId, businessUuid, userIntegrationId, params) => {
  const body = params && Object.keys(params).length > 0 ? qs.stringify(params) : undefined;
  const response = await newAPI.post(`${userId}/business/${businessUuid}/integrations/${userIntegrationId}/token/renew`, body);
  return response.data;
}

export const requestRemoveToken = async (userId, businessUuid, userIntegrationId) => {
  const response = await newAPI.delete(`${userId}/business/${businessUuid}/integrations/${userIntegrationId}/token/remove`);
  return response.data;
}